module.exports = __webpack_public_path__ + "media/images/landing/crime/product-8-281d6ffa1b5dd0fdd1920d04949ad9ab.png";